function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { UI, BuilderIcon } from "../../../builderUiTheme";
import { BLOCK_TEXT_WRAP_STYLE } from "../../constants/defaultBlocks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SidebarBlockGrid(_ref) {
  var items = _ref.items,
    onAdd = _ref.onAdd,
    onDragStart = _ref.onDragStart,
    _ref$accentColor = _ref.accentColor,
    accentColor = _ref$accentColor === void 0 ? UI.accent : _ref$accentColor;
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: 6
    },
    children: items.map(function (b) {
      return /*#__PURE__*/_jsxs("button", {
        type: "button",
        onClick: function onClick() {
          return onAdd(b);
        },
        draggable: Boolean(onDragStart),
        onDragStart: onDragStart ? function (e) {
          e.currentTarget.style.transform = "none";
          onDragStart(e, b.type);
        } : undefined,
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
          width: "100%",
          minWidth: 0,
          minHeight: 76,
          background: "#ffffff",
          border: "1px solid #e2e8f0",
          borderRadius: 8,
          padding: "12px 6px",
          color: "#475569",
          cursor: onDragStart ? "grab" : "pointer",
          fontSize: 14,
          fontWeight: 500,
          transition: "all 0.15s ease",
          boxShadow: "none",
          boxSizing: "border-box"
        },
        onMouseEnter: function onMouseEnter(e) {
          e.currentTarget.style.borderColor = "#0f172a";
          e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.05)";
          e.currentTarget.style.transform = "translateY(-1px)";
        },
        onMouseLeave: function onMouseLeave(e) {
          e.currentTarget.style.borderColor = "#e2e8f0";
          e.currentTarget.style.boxShadow = "none";
          e.currentTarget.style.transform = "translateY(0)";
        },
        children: [/*#__PURE__*/_jsx("span", {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            color: "#101828"
          },
          children: /*#__PURE__*/_jsx(BuilderIcon, {
            name: b.icon || b.type,
            size: 34,
            color: "currentColor"
          })
        }), /*#__PURE__*/_jsx("span", {
          style: _objectSpread({
            fontFamily: "DM Sans, sans-serif",
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.25,
            textAlign: "center",
            width: "100%",
            color: "#64748b"
          }, BLOCK_TEXT_WRAP_STYLE),
          children: b.label
        })]
      }, b.type || b.key);
    })
  });
}